// tslint:disable:max-line-length
import * as React from 'react';

import { Constants } from 'risesharp-common';

import { General } from './../parentClasses/general';
import { Helper } from './../utils/helper';
import ViewVideo from './../components/viewVideo';
import withTracker from './../layout/withTracker';

const imageFile = require('./../videos/10tips-job-interview-thumbnail.png');
const videoFile = require('./../videos/10tips-job-interview.mp4');

class StudentTenTips extends General {
  constructor(props: React.Props<any>) {
    super(props);
    this.trackContentHeight(true);
    this.displayTopLevelMessages(true);
  }
  
  componentDidMount() {
    this.trackContentHeight(false);
  }
  
  render() {
    return (
      <React.Fragment>
        {/* title */}
        {this.displayCustomTitleAndMeta(Constants.IDENTIFIER_STURES_TENTIPS)}
        <React.Fragment>
          <div className="container">
            <h3 className="my-3 pageTitle">Ten Tips to Prepare for a Job Interview</h3>
            <div className="my-3 outline">
              <ViewVideo
                id={'view_video'}
                videoUrl={videoFile}
                imgUrl={imageFile}
                trackStudentTasks={Helper.getStateFromHistory(this.props, 'trackStudentTasks') === 'Y'}
                containerStore={this.getContainerStoreFromProps()}
                isModal={false}
              />
            </div>
            <div className="my-3">
              Before you walk into a job interview, there are several things you can do to prepare to help you be ready to answer questions and outshine the other candidates.  Here are 10 things to do so that when you meet the interviewer, you feel calm and confident.
            </div>
            <div className="my-3">
              <p className="my-3">
                1. Spend time researching the company you are applying to. Look for news items online and through LinkedIn as well as on the company’s website, blog, and any social media sites. Being up to date on company news, will reduce the chances that you’ll be surprised by any company information the interviewer presents to you. 
              </p>
            </div>
            <div className="my-3">
              <p className="my-3">
                2. If you’re interviewing for a company that creates a product, be sure to get a look at it, or use it so that you are familiar with it before walking into your interview. 
              </p>
            </div>
            <div className="my-3">
              <p className="my-3">
                3. Ask who will be interviewing you. Read their bios on the company website, if available, and look at their profile on LinkedIn. You may see some things that you have in common to talk about at the interview. While it’s okay to research those interviewing you, do not connect with them on LinkedIn until you are offered the job.
              </p>
            </div>
            <div className="my-3">
              <p className="my-3">
                4. It’s a good idea to ask what the company’s dress code is. For a company where the dress code is business casual, men might wear dress slacks and a button-down shirt, and dress shoes. Women might wear a dress or skirt, blouse and sweater, or dress pants and dress shoes. For a company where the dress code is more formal, men and women should wear business suits. Get more information on what to wear in our blog, <a role="button" className="buttonAsLink" onClick={() => this.props.history.push('/students/resources/dress-code')}>How to Dress for a Job Interview</a>. 
              </p>
            </div>
            <div className="my-3">
              <p className="my-3">
                5. Try to arrive a few minutes early to the interview. Make sure you have directions to the company’s location where the interview is being held and the phone number. If you are delayed, be sure to call to notify the interviewer that you are running late. You don’t want to rush in late, and be stressed out. That will probably not result in a successful interview. 
              </p>
            </div>
            <div className="my-3">
              <p className="my-3">
                6. The interviewer will be asking you questions to learn more about your skills, abilities, and personality. Be prepared to talk about some things you have achieved at college or about instances where you have been successful. You want to show the interviewer that you have good judgment, take initiative, can work well on a team, and have good leadership abilities.  
              </p>
            </div>
            <div className="my-3">
              <p className="my-3">
                7. One question you’re likely to be asked is why you are interested in the job and why it’s the right fit for you. In your answer, consider using some of the points from the job description. For a customer support job, you might say something such as, “customer service is a good fit for me because I enjoy interacting with people, and I like being able to help people resolve their problems.”    
              </p>
            </div>
            <div className="my-3">
              <div className="my-3">
                8. In addition to answering questions, you should also be prepared to ask some questions. Usually at the end of the interview, you’ll be asked if you have any questions. Try to avoid questions that can only elicit yes or no answers. Instead, ask well-thought out questions that will show you have been researching the company and are interested in the job. Here are a few ideas of what to ask:
                <br/><br/>
                <ul>
                  <li>
                    Can you explain what I will be doing on a day-to-day basis on this job? -This question allows you to learn more about the job and the skills and abilities that are expected of you. 
                  </li>
                  <li>
                    What can someone in this job expect in terms of career growth? -This will help you understand whether people get promoted within the firm. This also shows that you are interested in staying with the company and advancing. Just be careful to ask the question in a way that does not make it appear that you are expecting to immediately get a promotion should you land the job.  
                  </li>
                  <li>
                    What are the next steps in the interview process? - By asking this question you are showing that you are interested in moving forward. The answer will provide you with information on whether you’ll interview with additional decision makers as well as the hiring timeline. 
                  </li>
                </ul>
              </div>
            </div>
            <div className="my-3">
              <p className="my-3">
                9. Stay away from bringing up salary during the first interview. As a new graduate, there is usually not a lot of room to negotiate your salary. If you bring up the salary topic too early in the interview process, then it might make the interviewer think that you are more interested in the money than the job itself. However, you should be knowledgeable about what the salary is for similar positions should the interviewer question you about how much you expect to be paid. Be sure that you state that you are flexible on the salary so that you do not overvalue or undervalue yourself.
              </p>
            </div>
            <div className="my-3">
              <p className="my-3">
                10. At the end of the interview, ask for a business card from each interviewer so that you have their contact information. Within 24 hours of the interview, or sooner if possible, email each interviewer a thank you note expressing your appreciation for the interview. You can also reiterate why you want the job, your qualifications, and how you are a good fit for the company. If you realize there was something you forgot to mention in the interview, you can include it in the thank you letter. Keep it brief, and close the letter by saying that you look forward to hearing from them regarding the position. 
              </p>
            </div>
            <div className="my-3">
              <p className="my-3">
                You may also want to read <a role="button" className="buttonAsLink" onClick={() => this.props.history.push('/students/resources/hired-quickly')}>10 Tips to Help You Get Hired Quickly.</a> 
              </p>
            </div>
          </div>
        </React.Fragment>
      </React.Fragment>
    );
  }

  // display sections
  private displayCustomTitleAndMeta(identifier: string) {
    return this.getHelmetData({
      identifier,
      college_name: Helper.getCollegeName(this.props)
    });
  }
}

export default withTracker(StudentTenTips);
